<template>
  <article class="@container/tile flex flex-row in-[.group\/popup]:flex-col justify-between gap-4">
    <div class="flex flex-col gap-y-5.5 gap-x-4 grow min-w-0">
      <div class="space-y-3.5">
        <USkeleton class="h-6 @xs/tile:h-7 w-3/4" />
        <USkeleton class="h-4.5 w-1/2" />
      </div>

      <USkeleton class="h-4.5 w-2/3" />
    </div>
    <USkeleton class="size-10 rounded shrink-0" />
  </article>
</template>
